module.exports = __webpack_public_path__ + "img/proyecto_2.b76718b7.png";